module.exports = __webpack_public_path__ + "img/enfermeria-foto2.e881b791.png";